<app-sidebar 
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Org Admin">
</app-sidebar>



